import React from 'react';

export const pageMeta = {
  "name": "DOM Event Listener",
  "link": "/javascript/dom/event-listener"
};

export default function JavascriptDomEventListener() {
  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h2 className="text-2xl font-semibold mb-2">DOM Event Listener</h2>
      <p>Route: /javascript/dom/event-listener</p>
      <h3 className="mt-4 font-medium">sub_content</h3>
      <pre>{JSON.stringify(pageMeta, null, 2)}</pre>
    </div>
  );
}
